import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as theme from "../theme";
import Switch from "@material-ui/core/Switch";
// import { ExportToCsv } from "export-to-csv";
import Loader3Orange from "../general/Loader3Orange";
import {
  getBrokeragesList,
  loadBrokerages,
  brokerageSelected,
  getBrokeragesReport,
  getReport,
} from "../store/brokerages";
import Select from "react-dropdown-select";
import Reports from "./reports/Reports";

const BrokerageSuperAdminReports = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadBrokerages());
  }, [dispatch]);
  const [loading, setLoading] = useState(false);
  const brokerages = useSelector(getBrokeragesList);
  const brokerageReport = useSelector(getBrokeragesReport);

  useEffect(() => {
    console.log("Brokerage Report has been loaded");
    console.log(brokerageReport);
    if (brokerageReport.length) {
      const options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
        filename: "InsurerList",
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };
      // const csvExporter = new ExportToCsv(options);
      // csvExporter.generateCsv(brokerageReport);
      setLoading(false);
    }
  }, [brokerageReport]);

  const onChangeHandle = (value) => {
    setLoading(true);
    console.log(value[0].code);
    console.log(brokerages.find((x) => x.code == "BR2"));
    dispatch(getReport(value[0].code));
  };

  console.log(brokerages[0]);
  return (
    <div>
      <div
        style={{
          width: "100%",
          display: "flex",
          padding: "20px",
        }}
      >
        <Reports />
        {/* <div style={{ width: "80%", marginLeft: "10%", marginTop: "20px" }}>
          <Select
            placeholder={"Search for a brokerage"}
            color={theme.COLORS.primary_navyblue}
            searchable={true}
            onChange={(values) => onChangeHandle(values)}
            values={[{ label: "test", value: "v" }]}
            options={[{ name: "Broker List", code: "BrokerList" }]}
            style={{
              width: "100%",
              height: "6vh",
              fontSize: "1.9vmin",
              border: "5px solid white",
              borderRadius: 15,
              fontFamily: "GibsonRegular",
            }}
            labelField={"name"}
            valueField={"code"}
            dropdownHeight={"58vh"}
          />
        </div> */}
      </div>
      {/* <PaymentDetailsPane loading={loading} ></PaymentDetailsPane> */}
    </div>
  );
};

const PaymentDetailsPane = (props) => {
  console.log("setLoading:", props.loading);
  return (
    <div
      style={{
        margin: "3.5rem",
        marginTop: "1.5rem",
        marginBottom: "50vh",
        overflow: "hidden",
      }}
    >
      <div>
        <h5
          class="px-2"
          style={{
            fontFamily: "GibsonSemiBd",
            justifyContent: "center",
            fontSize: "1.2vw",
          }}
        >
          Choose from dropdown to download csv report
        </h5>
        {props.loading ? (
          <div
            style={{
              width: "100%",
            }}
          >
            <Loader3Orange></Loader3Orange>
          </div>
        ) : (
          <div />
        )}
      </div>
    </div>
  );
};

export default BrokerageSuperAdminReports;
